import { render, staticRenderFns } from "./BotSettingsEmpty.vue?vue&type=template&id=d7d07320&"
import script from "./BotSettingsEmpty.vue?vue&type=script&lang=js&"
export * from "./BotSettingsEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports